import { fixHex } from 'utils/convert';

export const getColorHighlight = (hex: string, percentageIncrease = 10) => {
  /** converts hex to rgb by fraction of one */
  const fixedHex = fixHex(hex);
  const r = parseInt(fixedHex.slice(1, 3), 16) / 255;
  const g = parseInt(fixedHex.slice(3, 5), 16) / 255;
  const b = parseInt(fixedHex.slice(5, 7), 16) / 255;

  /** min, max, delta */
  const min = Math.min(r, g, b);
  const max = Math.max(r, g, b);
  const delta = max - min;

  /** long process to get the hue */
  let hue = 0;

  if (delta === 0) {
    hue = 0;
  } else if (max === r) {
    hue = ((g - b) / delta) % 6;
  } else if (max === g) {
    hue = (b - r) / delta + 2;
  } else {
    hue = (r - g) / delta + 4;
  }

  hue = Math.round(hue * 60);
  if (hue < 0) {
    hue += 360;
  }

  /** light and saturation */
  const light = (max + min) / 2;
  const saturation = delta === 0 ? 0 : delta / (1 - Math.abs(2 * light - 1));

  return `hsl(${hue}, ${saturation * 100}%, ${light * 100 + percentageIncrease}%)`;
};
